export function isStoryPromoted(storyId?: number, promotedStoriesIds?: Set<string>) {
  return Boolean(storyId && promotedStoriesIds?.has(storyId.toString()));
}
